'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('services.adminEmailTemplates', [])

.factory('adminEmailTemplatesService', ['$http', '$q', function ($http, $q) {

    var service = {};
    var baseUrl = environment.apiUrl + '/ID/Administration/EmailTemplate/API';

    // HttpGet
    service.getEmailTemplates = function () {
        return $http.get(baseUrl, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    service.getEmailTemplateByCode = function (emailTemplateCode) {
        return $http.get(baseUrl + '/' + emailTemplateCode, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // HttpPost
    service.getRenderedTemplateWithoutInliner = function (emailTemplateCode, rawTemplate, rawTemplateFR) {
        return $http.post(baseUrl + '/' + emailTemplateCode +
                          '/RenderedTemplateWithoutInliner', {
                              'rawTemplate': rawTemplate,
                              'rawTemplateFR': rawTemplateFR
                          })
        .then(function (response) {
            return response.data;
        });
    }

    service.updateRenderedTemplate = function (emailTemplateCode, markdownTmpl, markdownTmplFR, renderedTemplate) {
        return $http.post(baseUrl + '/' + emailTemplateCode +
                          '/UpdateRenderedTemplate',
                          {
                              'renderedTemplate': renderedTemplate,
                              'markdownTmpl': markdownTmpl,
                              'markdownTmplFR': markdownTmplFR
                          })
        .then(function (response) {
            return response.data;
        });
    }

    service.updateConfigTemplate = function (emailTemplate) {
        return $http.post(baseUrl + '/' + emailTemplate.Code +
                          '/UpdateConfig', {
                              'emailTemplate': emailTemplate
                          })
        .then(function (response) {
            return response.data;
        });
    }

    return service;
}]);
